import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { get, isArray, isEmpty, isNull, join, map } from 'lodash';

import BasicDetails from '../basicDetails/BasicDetails';
import DomainSearch from './DomainSearch';
import {
    saveGetDomainPage,
    setStepNumber,
    trackEvent as trackEventAction,
} from '../../store/signup/signupAction';
import Loader from '../../components/Loader';
import { INF_ERROR_CODES } from '../../utilities/constants';

/**
 * Get domain component
 * @param {*} param0
 */
const GetDomain = ({
    basicData,
    domainPageData,
    currentStep,
    setStepNumber,
    trackEvent,
    saveGetDomainPage,
    domainPurchaseErrors,
    initData,
}) => {
    const history = useHistory();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [useOldAddress, setUseOldAddress] = useState(true);
    const [domainNameError, setDomainNameError] = useState(false);
    const [businessNameError, setBusinessNameError] = useState(false);
    const [industryError, setIndustryError] = useState(false);

    useEffect(() => {
        if (domainPurchaseErrors) {
            setUseOldAddress(false);
        }
    }, [domainPurchaseErrors]);
    useEffect(() => {
        if (isNull(basicData)) {
            history.push('/need-domain');
        }
    }, [basicData, history, location]);

    const initialValues = {
        firstName: get(basicData, 'first_name'),
        lastName: get(basicData, 'last_name'),
        email: get(basicData, 'email'),
        phoneNumber: get(basicData, 'phone'),
        country: get(basicData, 'country'),
        street: get(basicData, 'street'),
        city: get(basicData, 'city'),
        state: get(basicData, 'state'),
        zipcode: get(basicData, 'zip_code'),
        countryCode: get(basicData, 'dial_code'),
    };
    /**
     * Submit function
     * @param {*} data
     */
    const submit = (data) => {
        if (validateDomainPageData(domainPageData)) {
            saveGetDomainPage({ ...domainPageData, formData: data });
            trackEvent(process.env.REACT_APP_TRACKER_NORMAL_SIGNUP_STEP_2_ENDPOINT_ID, {
                domainName: get(domainPageData, 'domainName'),
                businessName: get(domainPageData, 'businessName'),
                businessTypes: join(map(get(domainPageData, 'businessTypes', []), 'label'), ', '),
                firstName: get(basicData, 'first_name', ''),
                lastName: get(basicData, 'last_name', ''),
                email: get(basicData, 'email', ''),
                formId: get(basicData, 'form_id', ''),
            });
            // setStepNumber(currentStep + 1);
            history.push('/registration/choose-plan');
        }
    };
    /**
     * validate domain page section
     * @param {*} domainPageData
     */
    const validateDomainPageData = (domainPageData) => {
        let retvalue = true;
        setBusinessNameError(false);
        setIndustryError(false);
        setDomainNameError(false);
        if (isEmpty(domainPageData.businessName)) {
            setBusinessNameError(true);
            retvalue = false;
        }
        if (isEmpty(domainPageData.businessTypes)) {
            setIndustryError(true);
            retvalue = false;
        }
        if (!get(domainPageData, 'domainDetails.available', false)) {
            setDomainNameError(true);
            retvalue = false;
        }
        return retvalue;
    };
    /**
     * Render error messges section
     */
    const renderErrorMessages = () => {
        let message = '';
        if (domainPurchaseErrors === INF_ERROR_CODES.INF_DOMAIN_REGISTERED) {
            message =
                'This domain has already been registered under InfinCE. Please try another domain';
        } else if (isArray(domainPurchaseErrors)) {
            message = `These fields are invalid : ${domainPurchaseErrors.map(
                (err) => (err !== 'postalCode' ? err + ' ' : 'Zip Code ')
            )}`;
        } else {
            message = `Something unexpected happened. Please check you details and try again.`;
        }

        return <p className="input-error">{message}</p>;
    };
    return (
        <div className="content getdomain">
            {isLoading && <Loader />}
            <div className="content-block-right">
                <h1>Get Domain</h1>
                <p>
                    Let's get your domain. Choose domain name & confirm your
                    content.
                </p>
                <div className="sec-header-block"></div>
                <DomainSearch
                    initData={initData}
                    setIsLoading={setIsLoading}
                    domainNameError={domainNameError}
                    businessNameError={businessNameError}
                    industryError={industryError}
                    setIndustryError={setIndustryError}
                    setBusinessNameError={setBusinessNameError}
                    setDomainNameError={setDomainNameError}
                />

                <p>
                    <input
                        name="useSameAddress"
                        type="checkbox"
                        checked={useOldAddress}
                        onChange={(e) => setUseOldAddress(e.target.checked)}
                    />
                    Share the address provided in Step 1 with GoDaddy for domain
                    registration.
                </p>
                {!useOldAddress && (
                    <p>
                        These address details will be sent to GoDaddy for
                        registering your domain. The address provided in Step 1
                        has been copied for convenience. Please change if
                        required.
                    </p>
                )}
                {domainPurchaseErrors && renderErrorMessages()}
                <div style={useOldAddress ? { display: 'none' } : {}}>
                    <BasicDetails
                        submit={submit}
                        erroredFields={domainPurchaseErrors}
                        setLoading={setIsLoading}
                        initialValues={initialValues}
                        domainPurchaseErrors={domainPurchaseErrors}
                    />
                </div>

                <p className="mb-0">
                    By clicking next you agree to GoDaddy{' '}
                    <a
                        href="https://in.godaddy.com/agreements/showdoc"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        Terms of Service.
                    </a>
                </p>
            </div>
        </div>
    );
};
const mapDispatchToProps = {
    setStepNumber,
    saveGetDomainPage,
    trackEvent: trackEventAction,
};
const mapStateToProps = (store, props) => ({
    currentStep: store.signupReducer.currentStep,
    needDomain: get(store, 'signupReducer.needDomain', null),
    stateList: get(store, 'signupReducer.stateData.states', []),
    basicData: get(store, 'signupReducer.basicData', null),
    domainPageData: get(store, 'signupReducer.getDomain', null),
    domainPurchaseErrors: get(store, 'signupReducer.domainPurchaseErrors'),
    initData: get(store, 'signupReducer.getDomain', {}),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetDomain);
